const Config = {
  // MAIN_URL: "http://192.168.1.113:16888"
  // MAIN_URL: " http://api.hknegrc.com"
  // MAIN_URL: "http://43.135.69.95:26888",
  MAIN_URL: "http://43.135.69.95:16888",

}

export default Config; 
